import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import { Flex } from 'src/components/Flex';
import { createColumnDef } from 'src/components/NPIDataGrid/NPIDataGrid.utils';
import StatusChip from 'src/components/UserStatusChip/UserStatusChip';
import { formatDate } from 'src/utils/utils';

export const selfBillingInvoiceGridColDefs = () => {
    return [
        createColumnDef({
            field: 'sageInvoiceNumber',
            headerName: 'Invoice No.',
        }),
        createColumnDef({
            field: 'partnerName',
            headerName: 'Partner Name',
        }),
        createColumnDef({
            field: 'statementDate',
            headerName: 'Invoice Date',
            align: 'center',
            renderCell: ({ row }) => {
                const statementDate = row.commissionStatements?.[0]?.statementDate;
                return (
                    <Flex alignItems={'center'} height={'100%'}>
                        {statementDate ? formatDate(statementDate) : 'N/A'}
                    </Flex>
                );
            },
        }),
        createColumnDef({
            field: 'status',
            headerName: 'Status',
            align: 'center',
            renderCell: (params: GridRenderCellParams) => {
                const { status } = params.row;
                return (
                    <Flex>
                        {status ? <StatusChip status={status} type="salesInvoice" /> : 'N/A'}
                    </Flex>
                );
            },
        }),
    ];
};

export default selfBillingInvoiceGridColDefs;
